import React from "react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";

const Pagination = ({ page, setPage, totalPages }) => {
  return (
    <div className="page-main">
      <div className="page-section">
        <div className="pagination">
          <button
            className="greyButton"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            <FaLessThan />
          </button>
          <span className="pagination-button">{page}</span>
          <button
            className="greyButton"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            <FaGreaterThan />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;